module.exports = __webpack_public_path__ + "static/eddie-f44a1fbdca3bbde31da3e62c999139b4.jpg";